import { SlidersHorizontal } from "lucide-react";
import { Button } from "~/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "~/components/ui/dropdown-menu";
import { ChevronDownIcon } from "~/icons/ChevronDownIcon";

export function SearchSettingsControl({
  label,
  options,
  icon,
  value,
  onValueChange,
}: {
  label: string;
  options: Record<string, string>;
  icon: React.ReactNode;
  value: string;
  onValueChange: (value: string) => void;
}) {
  return (
    <div className="">
      <span className="pl-1 md:pl-4 text-sm font-medium line-clamp-1 w-full block">
        {label}
      </span>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="flatWhite" className="w-full min-w-0" id="filter-button">
            <span className="grow min-w-0 overflow-hidden text-left truncate">
              {options[value]}
            </span>
            <ChevronDownIcon className="size-5" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent side="bottom" align="start" className="w-56">
          <DropdownMenuRadioGroup value={value} onValueChange={onValueChange}>
            {Object.keys(options).map((key) => (
              <DropdownMenuRadioItem key={key} value={key}>
                {options[key]}
              </DropdownMenuRadioItem>
            ))}
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
